import { Component, OnInit, AfterViewChecked, Input, ElementRef, EventEmitter, Output, DoCheck, ViewChildren, QueryList, ViewChild, } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoggerService } from '@kpmg-tax/core';
import { Observable, of, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError, tap, } from 'rxjs/operators';
import { ToastrService } from '@kpmg-tax/ui';
import { DatePipe, formatDate } from '@angular/common';
// import { Options } from '@angular-slider/ngx-slider';
import { CreateStudyService } from './services/create-study.service';
import { RightSideDrawerService } from '../../../shared/right-side-drawer/right-side-drawer.service';
import { SessionService } from '../../../shared/session-service/session.service';
import { SESSION_CONST } from '../../../shared/constants/session-constants';
import { BaseResponse } from '../../../shared/models/base-response.model';
import { Engagement } from '../../models/engagement/engagement.model';
import { Messages } from '../../../shared/constants/messages';
import { ROUTE_URL } from '../../../shared/constants/route-constants';
import { role } from '../../../shared/constants/role-enum';
import { WhiteSpaceValidator } from '../../../core/validators/whitespace-validator';
import { GetClientsResponse } from '../../models/get-clients-response.model';
import { AdminClientUsersService } from 'src/app/admin/admin-client-users/admin-client-users.service';
import { APP_CONSTANTS } from '../../constants/app-constants';
import { EngagementFlagOptions, EngagementFlag } from '../../../shared/constants/engagement-flag';
import { CustomDropDown } from '../../models/custom-dropdown.model';
import { encodeText, decodeText } from 'src/app/shared/lib/custom-tools';

@Component({
    selector: 'create-study',
    templateUrl: './create-study.component.html',
    styleUrls: ['./create-study.component.scss'],
})

export class CreateStudyComponent implements OnInit, AfterViewChecked, DoCheck {
    emailReminderFrequencyOptions: any;
    engagementFlagOptions: EngagementFlagOptions;
    targetForm: FormGroup;
    subject: Subject<any> = new Subject();
    engagements: any;
    engagementNumberError: boolean = false;
    engagementNameError: boolean = false;
    getSearchlistUserNames: any;
    engagementCreated: any;
    notfound: string = 'Sorry, user name not found!';
    noResults: boolean;
    kpmgUsers: any = [
        // blank user to pass in to prevent observable error
        {
            firstName: 'rdetest',
            lastName: 'rdetest',
            email: 'rdetest@kpmg.com',
        },
    ];
    kpmgUsersSelected: any = [];
    engagementManagerSelected: any = [];
    engagementPartnerSelected: any = [];
    engagementManagerSelectedId: number = 0;
    engagementPartnerSelectedId: number = 0;
    clients: GetClientsResponse;
    clientUsers: any;
    clientUsersSelected: any = [];
    clientIdSelected: number = 0;
    engagementUsers: any = [];
    isSearchKPMG: boolean;
    startDateError: boolean = false;
    isStartDateRequired: boolean = false;
    startDate: Date = null;
    endDate: Date = null;
    maxDate: Date = new Date(2999, 25, 12);
    engagementClient: string = '';
    minDate: Date = new Date();
    @ViewChild('dpStart', { static: true }) dpStart;
    @ViewChild('dpEnd', { static: true }) dpEnd;
    isDisabled: boolean = false;
    isClientSelected: boolean = false;
    clientNameChanged: Subject<string> = new Subject<string>();
    engagementNumberChanged: Subject<string> = new Subject<string>();
    engagementNameChanged: Subject<string> = new Subject<string>();
    RCSWatsonQuestion = new Map<number, boolean>();
    RCSWatsonvalues = new Map<string, boolean>();
    RCSContractvalues = new Map<string, boolean>();
    enableRCSWatson: boolean = false;
    enableRCSContract: boolean = false;
    RCSWatsonCount: number = 0;
    RCSquestiondata: any[] = [];
    @ViewChildren('questions') private questions: QueryList<ElementRef>;
    @Output() drawerWidth = new EventEmitter<string>();

    @Input() mandatoryindicator: boolean;
    isClientMode: boolean = false;
    reminderValue: number = 0;
    studyFlagOptionId: number = 2;
    demoClientUsers: any[];
    createEngagementFormSubmitCount: number = 0;
    noResultflag: boolean;
    isHidden: boolean = true;
    isHidden2: boolean = true;
    RCSWatsonData: any;
    questiondata: any;
    RCSContractData: any;
    questiondataContract: any;
    showyesWError: boolean = false;
    RCSContractDataDup: any;
    RCSWatsonDataDup: any;
    RCSContractQuestion = new Map<number, boolean>();
    RCSContractcount: number = 0;
    finalEngagementManagerstrKPMG: string;
    engagementManagerKPMGUser: boolean = false;
    finalEngagementPartnerstrKPMG: string;
    engagementPartnerKPMGUser: boolean = false;
    finalAddKPMGUserstrKPMG: string;
    engagementAddKPMGUser: boolean = false;
    taxYear: string = '';
    emailReminderText = 'No reminders';
    dropdownWidth = '19em';
    emailReminderOptions: CustomDropDown[] = []; //string[] = [];
    canSMEAddProjects: boolean = false;
    canSMEAddEmployees: boolean = false;
    currentUser = this.sessionService.getSession('userName');
    currentUserId = Number(this.sessionService.getSession('currentUserId'));
    @ViewChild('custSearch') defaultClientName: ElementRef;
    userDetails: any = [];
    totalEngCounts: number;
    isDemoClickedFirst: boolean = false;

    constructor(
        public rightSideDrawerService: RightSideDrawerService,
        public sessionService: SessionService,
        public _loggingService: LoggerService,
        public _toasterService: ToastrService,
        private router: Router,
        private http: HttpClient,
        private formBuilder: FormBuilder,
        public datePipe: DatePipe,
        private _createStudyService: CreateStudyService,
        public _clientUserService: AdminClientUsersService) {
        this.getEmailReminderFrequency();
        this.emailReminderFrequencyOptions = this._createStudyService.getEmailReminderFrequencyOptions();
        this.engagementFlagOptions = new EngagementFlagOptions();
    }

    getEmailReminderFrequency(): void {
        const emailFrequencies = APP_CONSTANTS.EMAIL_REMINDER_FREQUENCY;
        emailFrequencies.forEach((item, index) => {
            this.emailReminderOptions.push({ id: index, value: item, isDisabled: index === 0 ? true : false });
        });
    }


    // reset form content
    public resetRightSideDrawerData = () => {
        //this.targetForm.reset();
    }

    get f() {
        return this.targetForm?.controls;
    }

    ngDoCheck() {
        let value =
            this.targetForm.controls.engagementNumber.value ||
            this.targetForm.controls.clientName.value ||
            this.targetForm.controls.engagementName.value ||
            // this.targetForm.controls.EngagementManager.value ||
            // this.targetForm.controls.engagementPartner.value ||
            //this.targetForm.controls.taxYear.value ||
            this.targetForm.controls.engagementStartDate.value ||
            this.targetForm.controls.engagementEndDate.value ||
            this.targetForm.controls.engagementEmailFrequency.value ||
            this.kpmgUsersSelected.length > 0 ||
            this.clientUsersSelected.length > 0 ||
            this.engagementManagerSelectedId > 0 ||
            this.engagementPartnerSelectedId > 0;

        if (value) {
            this.rightSideDrawerService.setMandatoryField(true, 'Create Study');
        } else {
            this.rightSideDrawerService.setMandatoryField(false, '');
        }
    }

    ngOnInit() {
        this.getClientNames();
        this.getKPMGUsers();
        this.isClientMode =
            this.sessionService.getSession(SESSION_CONST.ISCLIENTMODE) === 'true';
        if (this.isClientMode) {
            this.engagementClient = this.rightSideDrawerService.singleRowAddData;
        }
        this.targetForm = this.formBuilder.group({
            clientName: ['', Validators.required],
            engagementName: [
                '',
                [Validators.required, WhiteSpaceValidator.cannotContainSpace],
            ],
            engagementNumber: ['', [Validators.pattern('^[a-zA-Z0-9]+$')]],
            engagementStartDate: ['', Validators.required],
            engagementEndDate: [''],
            engagementEmailFrequency: ['3', [Validators.pattern('^([0-9]|1[0-4])$')]],
            totalHours: ['2096'],
            standardNonWorkingHours: ['120'],
            priorYearQre: [],
            estimatedQre: []
        });
        this.drawerWidth.emit('calc(61vw - 100px)');
    }

    ngAfterViewChecked() {
        // Refresh form inputs if drawer is opened or loaded.

        if (this.rightSideDrawerService.triggerRightSideDrawerClick) {
            this.rightSideDrawerService.triggerRightSideDrawerClick = false; // Set trigger to false so that this action is only performed once. Without this, the form would keep resetting on every change on any input.
            this.resetRightSideDrawerData();
            if (this.isClientMode) {
                this.engagementClient = this.rightSideDrawerService.singleRowAddData;
            }
        }
    }

    onEmailFrequencySelected(selectedOption: CustomDropDown): void {
        if (selectedOption !== null) {
            const emailFrequency = this.emailReminderOptions.find(item => item.id === selectedOption.id);
            this.reminderValue = emailFrequency && emailFrequency.value.includes(selectedOption.id.toString()) ? emailFrequency.id : 0;
        }
    }

    setStartDate(date: Date) {
        if (date !== null) {
            this.isStartDateRequired = false;
            this.startDate = date;
            this.minDate = date;
            this.taxYear = this.startDate ? this.startDate.getFullYear().toString() : ''
            if (this.startDate && this.endDate) {
                this.checkValidDates();
            }
        } else {
            this.isStartDateRequired = this.startDate !== null
        }
    }

    setEndDate(date: Date) {
        this.endDate = date;

        if (this.startDate && this.endDate) {
            this.checkValidDates();
        }
    }

    // Validate start date isn't greater than end date if end date is specified
    checkValidDates() {
        let startDateConverted = new Date(this.startDate);
        let endDateConverted = new Date(this.endDate);

        if (startDateConverted > endDateConverted) {
            this.startDateError = true;
        } else {
            this.startDateError = false;
        }
    }

    //Waits until all keystrokes have been entered before checking if an engagement name exists under the current entered client
    onClientNameChanged(clientName: string) {
        if (this.clientNameChanged.observers.length === 0) {
            this.clientNameChanged.pipe(debounceTime(250), distinctUntilChanged()).subscribe(() => {
                this.verifyClientWithID(this.engagementClient);
            });
        } else {
            this.isClientSelected = false;
        }
        this.clientNameChanged.next(clientName);
    }

    // Waits until all keystrokes have been entered before checking if engagement number already exists
    onEngagementNumberChanged(engNumber: string) {
        if (this.engagementNumberChanged.observers.length === 0) {
            //Once 250 milliseconds has passed after last keystroke, if the input is different from last call, check the engagement number.
            this.engagementNumberChanged.pipe(debounceTime(250), distinctUntilChanged()).subscribe(() => {
                this.checkEngagementNumber();
            });
        }
        this.engagementNumberChanged.next(engNumber);
    } // Waits until all keystrokes have been entered before checking if engagement name already exists

    onEngagementNameChanged(engName: string) {
        if (this.engagementNameChanged.observers.length === 0) {
            //Once 250 milliseconds has passed after last keystroke, if the input is different from last call, check the engagement name.
            this.engagementNameChanged.pipe(debounceTime(500), distinctUntilChanged()).subscribe(() => {
                this.checkEngagementName();
            });
        }
        this.engagementNameChanged.next(engName);
    }

    // check if engagement number already exists
    checkEngagementNumber() {
        let engagementNumber = this.targetForm.get('engagementNumber').value || '';
        if (engagementNumber && engagementNumber.trim().length > 0) {
            this._createStudyService.checkEngagementNumber(engagementNumber).subscribe((data: BaseResponse) => {
                if (data !== null && data.success) {
                    this.engagementNumberError = data.result;
                }
            });
        } else {
            this.engagementNumberError = false;
        }
    }

    // check if engagement name already exists
    checkEngagementName() {
        let engagementName = this.targetForm.get('engagementName').value || '';
        if (engagementName && engagementName.trim().length > 0 && this.clientIdSelected !== 0) {
            this._createStudyService.CheckEngagementName(engagementName.trim(), this.clientIdSelected).subscribe((data: BaseResponse) => {
                this.engagementNameError = data.result;
            });
        } else {
            this.engagementNameError = false;
        }
    }

    // get KPMG users
    getKPMGUsers(): void {
        this._createStudyService.kpmgUsersDataSource$.subscribe(kpmgUsersResponse => {
            if (kpmgUsersResponse && kpmgUsersResponse.result) {
                this.kpmgUsers = kpmgUsersResponse;
            }
        });
    }

    // get client users
    getClientUsers(clientId: number) {
        this.clientIdSelected = clientId;
        this._createStudyService.GetClientUsers(clientId).subscribe(
            (data: BaseResponse) => {
                this.clientUsers = data.result;
            });
    }

    // Filter clientUsers autosuggest
    private searchClientUsers(term: any): Observable<any> {
        if (this.clientUsers) {
            return of(
                this.clientUsers.filter(
                    item => item.displayName.toLowerCase().includes(term.toLowerCase()),
                    //||
                    //item.email.toLowerCase().includes(term.toLowerCase()),
                ),
            );
        } else {
            return of([]);
        }
    }

    // Search KPMG Users
    searchKPMG(bool: boolean) {
        this.isSearchKPMG = bool;
    }

    // format for employees search
    kpmgUserFormatter = (result: any) => '';
    clientUserFormatter = (result: any) => '';

    removeUserFromEngagement(row) {
        this.engagementUsers.splice(
            this.engagementUsers.findIndex(item => item.userName === row.userName),
            1,
        );
        this.engagementUsers = [...this.engagementUsers];
    }

    // Filter clients autosuggest
    private searchClients(term: any): Observable<any> {
        if (this.clients && this.clients.result && this.clients.result.length !== 0) {
            return of(
                this.clients.result.filter(item =>
                    item.clientName.toLowerCase().includes(term.toLowerCase()),
                ),
            );
        } else {
            return of([]);
        }
    }

    // get clients
    getClientNames() {
        this._createStudyService.clientUsersDataSource$.subscribe(clientData => {
            if (clientData && clientData.result)
                this.clients = clientData;
            if (this.isClientMode) {
                this.showClientUsers(this.engagementClient);
            }
        });
    }

    // format for clients search
    clientFormatter = (result: any) =>
        result && result.clientName ? result.clientName.trim() : null

    // Autosuggest for Existing Client Names
    searchExistingClients = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(debounceTime(150), distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                // Remove "no results" message in case it was displayed from the previous search
                this.noResults = false;
                this.noResultflag = false;
            }),
            switchMap(term => {
                if (term !== '') {
                    // Process the search term entered
                    return this.searchClients(term).pipe(switchMap(data => {
                        this.engagementClient = term;
                        return of(data);
                    }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else {
                    return of([]);
                }
            }),
        )

    onClientSelected($event: any) {
        this.engagementClient = $event.item.clientName;
        this.isClientSelected = true;
        this.getClientUsers($event.item.clientId);
        //this.onClientNameChanged($event.item.clientName);
    }

    // getReminderFrequency(event: any) {
    //     this.reminderValue = event.target.selectedIndex === 0 ? 0 : event.target[event.target.selectedIndex].Value;
    // }
    // Create Engagement
    createStudy(): void {
        this.rightSideDrawerService.spinnerLoad(true);
        this.createEngagementFormSubmitCount = ++this
            .createEngagementFormSubmitCount;
        this.isDisabled = false;
        let engagement: Engagement = this.targetForm.value;

        let emailFreq = this.reminderValue;
        emailFreq === null ? (emailFreq = 0) : (emailFreq = emailFreq);
        engagement.clientName = this.engagementClient.trim();
        engagement.insertedBy = 0;
        engagement.isArchived = true;
        engagement.users = this.engagementUsers;
        engagement.reminderFrequency = emailFreq;
        engagement.taxYear = +this.taxYear;
        engagement.engagementFlagId = this.studyFlagOptionId;
        engagement.canSMEAddProjects = this.canSMEAddProjects;
        engagement.canSMEAddEmployees = this.canSMEAddEmployees;

        engagement.engagementName = encodeText(engagement.engagementName);
        engagement.engagementNumber = encodeText(engagement.engagementNumber);

        this.kpmgUsersSelected.forEach((kpmgUsers: any) => {
            engagement.users.push(kpmgUsers);
        });

        this.clientUsersSelected.forEach((clientUsers: any) => {
            engagement.users.push(clientUsers);
        });


        engagement.engagementManager = this.engagementManagerSelectedId;
        engagement.engagementPartner = this.engagementPartnerSelectedId;
        engagement.priorYearQre = engagement.priorYearQre !== null ? engagement.priorYearQre : 0;

        if (this.createEngagementFormSubmitCount === 1) {
            this._createStudyService.CreateEngagement(engagement).subscribe(
                (data: BaseResponse) => {
                    this.rightSideDrawerService.spinnerLoad(false);
                    // Refresh data table on page
                    this.targetForm.reset();
                    this.isDisabled = false;
                    this.rightSideDrawerService.closeRightSideDrawer();
                    // Go to engagement preparation
                    this.engagementCreated = data;
                    this._toasterService.setSuccessMessage(
                        Messages.Home.CreateEngagementSuccess,
                    );
                    this.sessionService.setSession(
                        'engagementId',
                        data.result.engagementId.toString(),
                    );
                    this.sessionService.setSession(
                        'clientId',
                        data.result.clientId.toString(),
                    );

                    this.sessionService.setEngagementNameAndNumber(decodeText(data.result.engagementName.toString()), decodeText(data.result.engagementNumber));
                    this.sessionService.setEngagementName(decodeText(data.result.engagementName.toString()));
                    this.sessionService.setSession('clientName', this.engagementClient.trim());

                    this.createEngagementFormSubmitCount = 0;
                    this.router.navigate([ROUTE_URL.STUDYHOME(data.result.engagementId.toString())]);
                    return;
                },
                // Show in console if there is an error given from the back end.
                error => {
                    //this.targetForm.reset();
                    this.rightSideDrawerService.spinnerLoad(false);
                    this.isDisabled = false;
                    this.createEngagementFormSubmitCount = 0;
                    this._toasterService.setErrorMessage(
                        Messages.Home.CreateEngagementFailure,
                    );
                },
            );
        }

    }

    // Search EngagementPartner
    searchEngagementPartnerStream = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(
            distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                // Remove "no results" message in case it was displayed from the previous search
                this.noResults = false;
            }),
            switchMap(term => {
                this.finalEngagementPartnerstrKPMG = '';
                if (term !== '' && this.isSearchKPMG === true) {
                    // Process the search term entered

                    return this.searchKPMGUsers(term).pipe(
                        switchMap(data => {

                            this.noResults = data.length === 0;
                            if (this.noResults === true) {
                                let str1 = 'Click here to add user.';
                                this.finalEngagementPartnerstrKPMG = 'user' + ' ' + term.bold() + ' not found' + ' ' + str1.italics();
                                let noData = [
                                    {
                                        email: null,
                                        isDelete: false,
                                        userName: this.finalEngagementPartnerstrKPMG,
                                    },
                                ];
                                this.engagementPartnerKPMGUser = true;
                                return of(noData);
                            } else {
                                this.engagementPartnerKPMGUser = false;
                                return of(data);
                            }
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.engagementClient !== 'KPMG Demo'
                ) {
                    return this.searchClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.engagementClient === 'KPMG Demo'
                ) {
                    return this.searchDemoClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else {
                    return of([]);
                    this.noResultflag = true;
                }
            }),
        )

    // Search Engagement manager Search Stream
    searchEngagementManagerStream = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(
            distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                // Remove "no results" message in case it was displayed from the previous search
                this.noResults = false;
            }),
            switchMap(term => {
                this.finalEngagementManagerstrKPMG = '';
                if (term !== '' && this.isSearchKPMG === true) {
                    // Process the search term entered
                    let str1 = 'Click here to add user.';
                    this.finalEngagementManagerstrKPMG =
                        'user' + ' ' + term.bold() + ' not found' + ' ' + str1.italics();
                    return this.searchKPMGUsers(term).pipe(
                        switchMap(data => {
                            let noData = [
                                {
                                    email: null,
                                    isDelete: false,
                                    userName: this.finalEngagementManagerstrKPMG,
                                },
                            ];
                            this.noResults = data.length === 0;
                            if (this.noResults === true) {
                                this.engagementManagerKPMGUser = true;
                                return of(noData);
                            } else {
                                this.engagementManagerKPMGUser = false;
                                return of(data);
                            }
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.engagementClient !== 'KPMG Demo'
                ) {
                    return this.searchClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.engagementClient === 'KPMG Demo'
                ) {
                    return this.searchDemoClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else {
                    return of([]);
                    this.noResultflag = true;
                }
            }),
        )

    // Search KPMG User and Client User
    searchUserStream = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(
            distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                // Remove "no results" message in case it was displayed from the previous search
                this.noResults = false;
            }),
            switchMap(term => {
                if (term !== '' && this.isSearchKPMG === true) {
                    // Process the search term entered
                    let str1 = 'Click here to add user.';
                    this.finalAddKPMGUserstrKPMG =
                        'user' + ' ' + term.bold() + ' not found' + ' ' + str1.italics();
                    return this.searchKPMGUsers(term).pipe(
                        switchMap(data => {
                            let noData = [
                                {
                                    email: null,
                                    isDelete: false,
                                    userName: this.finalAddKPMGUserstrKPMG,
                                },
                            ];
                            this.noResults = data.length === 0;
                            if (this.noResults === true) {
                                this.engagementAddKPMGUser = true;
                                return of(noData);
                            } else {
                                this.engagementAddKPMGUser = false;
                                return of(data);
                            }
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.engagementClient !== 'KPMG Demo'
                ) {
                    return this.searchClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.engagementClient === 'KPMG Demo'
                ) {
                    return this.searchDemoClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else {
                    return of([]);
                    this.noResultflag = true;
                }
            }),
        )

    // filter KPMG Users autosuggest
    private searchKPMGUsers(term: any): Observable<any> {
        if (this.kpmgUsers.result) {
            return of(
                this.kpmgUsers.result.filter(item =>
                    item.displayName.toLowerCase().includes(term.toLowerCase()),
                ),
            );
        } else {
            return of([]);
        }
    }

    private searchDemoClientUsers(term: any): Observable<any> {
        if (this.kpmgUsers.result || this.clientUsers) {
            let kpmgUserdata: any[] = this.kpmgUsers.result;
            let clientUserData: any[] = this.clientUsers;
            this.demoClientUsers = kpmgUserdata.concat(clientUserData);
            if (kpmgUserdata != null && clientUserData != null) {
                return of(
                    this.demoClientUsers.filter(item =>
                        item.displayName.toLowerCase().includes(term.toLowerCase()),
                    ),
                );
            } else if (kpmgUserdata != null && clientUserData == null) {
                return of(
                    kpmgUserdata.filter(item =>
                        item.displayName.toLowerCase().includes(term.toLowerCase()),
                    ),
                );
            } else {
                return of(
                    clientUserData.filter(item =>
                        item.displayName.toLowerCase().includes(term.toLowerCase()),
                    ),
                );
            }
        } else {
            return of([]);
        }
    }

    // On Engagement Partner selection
    onEngagementPartnerSelect($event: any) {
        let user = $event.item;
        if (user.userName.includes('Click here to add user.')) {
            //this.showAddUserModel = true;
            this._clientUserService.setFunctionTypeAndData(false, true, null);
            this.rightSideDrawerService.openRightSideDrawer('add-user-form');
            this.rightSideDrawerService.setIsSearchKPMG(this.isSearchKPMG);
            this.rightSideDrawerService.setIsFromCreateStudy(true);
        } else {
            this.engagementPartnerSelectedId = user.userId;
            let engagementUser = {
                userName: user.userName,
                firstName: user.firstName,
                lastName: user.lastName,
                displayName: user.displayName,
                email: user.email,
                userId: user.userId,
                roleId: role.admin,
            };
            this.engagementPartnerSelected = [];
            this.engagementPartnerSelected.push(engagementUser);
        }
    }

    removeEngagementPartnerSelected(row: any) {
        this.engagementPartnerSelectedId = 0;
        let removeIndex = this.engagementPartnerSelected.findIndex(
            item => item.userId === row.userId,
        );
        this.engagementPartnerSelected.splice(removeIndex, 1);
        this.engagementPartnerSelected = [...this.engagementPartnerSelected];
    }

    // On Engagement manager selection
    onEngagementManagerSelect($event: any) {
        let user = $event.item;
        if (user.userName.includes('Click here to add user.')) {
            //this.showAddUserModel = true;
            this._clientUserService.setFunctionTypeAndData(false, true, null);
            this.rightSideDrawerService.openRightSideDrawer('add-user-form');
            this.rightSideDrawerService.setIsSearchKPMG(this.isSearchKPMG);
            this.rightSideDrawerService.setIsFromCreateStudy(true);
        } else {
            let user = $event.item;
            this.engagementManagerSelectedId = user.userId;
            let engagementUser = {
                userName: user.userName,
                firstName: user.firstName,
                lastName: user.lastName,
                displayName: user.displayName,
                email: user.email,
                userId: user.userId,
                roleId: role.admin,
            };
            this.engagementManagerSelected = [];
            this.engagementManagerSelected.push(engagementUser);
        }

    }

    removeEngagementManagerSelected(row: any) {
        this.engagementManagerSelectedId = 0;
        let removeIndex = this.engagementManagerSelected.findIndex(
            item => item.userId === row.userId,
        );
        this.engagementManagerSelected.splice(removeIndex, 1);
        this.engagementManagerSelected = [...this.engagementManagerSelected];
    }

    // On KPMG user selection
    onKPMGUserSelect($event: any) {
        let user = $event.item;
        if (user.userName.includes('Click here to add user.')) {
            //this.showAddUserModel = true;
            this._clientUserService.setFunctionTypeAndData(false, true, null);
            this.rightSideDrawerService.openRightSideDrawer('add-user-form');
            this.rightSideDrawerService.setIsSearchKPMG(this.isSearchKPMG);
            this.rightSideDrawerService.setIsFromCreateStudy(true);
        } else {
            let engagementUser = {
                userName: user.userName,
                firstName: user.firstName,
                lastName: user.lastName,
                displayName: user.displayName,
                email: user.email,
                userId: user.userId,
                roleId: role.admin,
            };

            let index = this.kpmgUsersSelected.findIndex(
                item => item.userId === engagementUser.userId,
            );
            if (index !== -1) {
                return;
            }

            this.kpmgUsersSelected.push(engagementUser);
            this.kpmgUsersSelected = [...this.kpmgUsersSelected];
        }
    }

    removeKPMGUser(row: any) {
        let removeIndex = this.kpmgUsersSelected.findIndex(
            item => item.userId === row.userId,
        );
        this.kpmgUsersSelected.splice(removeIndex, 1);
        this.kpmgUsersSelected = [...this.kpmgUsersSelected];
    }

    // On KPMG user selection
    onClientUserSelect($event: any) {
        let user = $event.item;

        if (user.userName.includes('Click here to add user.')) {
            //this.showAddUserModel = true;
            this._clientUserService.setFunctionTypeAndData(false, true, null);
            this.rightSideDrawerService.openRightSideDrawer('add-user-form');
            this.rightSideDrawerService.setIsSearchKPMG(this.isSearchKPMG);
            this.rightSideDrawerService.setIsFromCreateStudy(true);
        } else {

            let engagementUser = {
                userName: user.userName,
                firstName: user.firstName,
                lastName: user.lastName,
                displayName: user.displayName,
                email: user.email,
                userId: user.userId,
                roleId: role.clientManager,
            };

            let index = this.clientUsersSelected.findIndex(
                item => item.userId === engagementUser.userId,
            );
            if (index !== -1) {
                return;
            }

            this.clientUsersSelected.push(engagementUser);
            this.clientUsersSelected = [...this.clientUsersSelected];
        }
    }

    removeClientUser(row: any) {
        let removeIndex = this.clientUsersSelected.findIndex(
            item => item.userId === row.userId,
        );
        this.clientUsersSelected.splice(removeIndex, 1);
        this.clientUsersSelected = [...this.clientUsersSelected];
    }

    showClientUsers(text: any) {
        if (text) {
            if (this.isClientMode) {
                this.engagementClient = text;
            }
            this.clientUsersSelected = [];
            let index = this.clients.result.findIndex(
                item => item.clientName.toLowerCase() === text.toLowerCase(),
            );
            if (index !== -1) {
                this.getClientUsers(this.clients.result[index].clientId);
                //this.checkEngagementName();
            } else {
                this.clientUsers = null;
            }
        }
    }

    //Based on the entered Client Name, verifies if a client with that name already exists. If it does, verifies if an entered engagement name already exists under that client.
    verifyClientWithID(clientName: string) {
        if (clientName) {
            if (this.isClientMode) {
                this.engagementClient = clientName;
            }
            this.clientUsersSelected = [];
            let index = this.clients.result.findIndex(item => item.clientName.toLowerCase() === clientName.toLowerCase());
            if (index !== -1) {
                this.getClientUsers(this.clients.result[index].clientId);
                this.checkEngagementName();
            } else {
                this.clientIdSelected = 0;
                this.clientUsers = null;
                this.engagementNameError = false;
            }
        }
    }

    trimSpecialChar(ctrl: any) {
        const ctrlVal = this.targetForm.get(ctrl).value;
        if (ctrlVal) {
            this.targetForm.controls[ctrl].setValue(
                ctrlVal.replace(/[^a-zA-Z0-9-()._/ ]/g, ''),
            );
        }
    }

    onfocStartDate() {
        setTimeout(() => {
            this.dpEnd.hide();
        }, 50);
    }

    onfocEndDate() {
        setTimeout(() => {
            this.dpStart.hide();
        }, 50);
    }

    onfocEF() {
        this.dpEnd.hide();
    }

    openDatePickerEnd() {
        this.dpEnd.toggle();
    }

    openDatePickerStart() {
        this.dpStart.toggle();
    }

    clearStartDate() {
        this.targetForm.controls.engagementStartDate.setValue(null);
    }
    clearEndDate() {
        this.targetForm.controls.engagementEndDate.setValue(null);
    }
    onCancel() {
        this.rightSideDrawerService.closeRightSideDrawer();
    }
    setReminder(value) {
    }

    flagOptionClick(optionId: number) {
        this.studyFlagOptionId = optionId;
        if (this.studyFlagOptionId === 1) {
            this.targetForm.patchValue({ clientName: 'AMCS Demo' });
            this.defaultClientName.nativeElement.value = "AMCS Demo"
            this.engagementClient = "AMCS Demo";
            let today = new Date();
            let monDate = formatDate(today, 'shortDate', 'en-US').replace(/\//g, '').substring(0, 4);
            let time = formatDate(today, 'mediumTime', 'en-US').substring(0, 7).replace(/:/g, '');
            let formatedDate = formatDate(today, 'mediumDate', 'en-US').replace(',', '');
            this.targetForm.patchValue({ engagementName: 'AMCS Demo - ' + formatedDate });
            this.targetForm.patchValue({ engagementNumber: 'Demo' + monDate + time });

            let currentYear = today.getFullYear();
            const lastYear = currentYear - 1;
            this.targetForm.patchValue({ engagementStartDate: '01 01 ' + lastYear }); ///MM/DD
            this.targetForm.patchValue({ engagementEndDate: '12 31 ' + lastYear }); ///MM/DD
            this.engagementPartnerSelectedId = this.currentUserId;
            this.engagementManagerSelectedId = this.currentUserId;
            this.userDetails = this.kpmgUsers.result.find(x => x.userId === this.currentUserId);
            let engagementUser = {
                userName: this.userDetails.userName,
                firstName: this.userDetails.firstName,
                lastName: this.userDetails.lastName,
                displayName: this.userDetails.displayName,
                email: this.userDetails.email,
                userId: this.userDetails.userId,
                roleId: role.admin,
            };
            this.engagementManagerSelected = [];
            this.engagementManagerSelected.push(this.userDetails);
            this.engagementPartnerSelected = [];
            this.engagementPartnerSelected.push(engagementUser);
            this.emailReminderText = "Every 3 days";
            this.reminderValue = 3;
            this.isDemoClickedFirst = true;
        } else if (this.isDemoClickedFirst) {
            this.targetForm.reset();
            this.emailReminderText = 'No reminders';
            this.reminderValue = 0;
            this.targetForm.patchValue({ totalHours: '2096' });
            this.targetForm.patchValue({ standardNonWorkingHours: '120' });
            this.engagementManagerSelected = [];
            this.engagementPartnerSelected = [];
            this.engagementManagerSelectedId = 0;
            this.engagementPartnerSelectedId = 0;
        }
    }


    onRCSWatsonSelect() {
        let questions = this.RCSWatsonData.sort(i => i.questionOrder);
        this.questiondata = questions.filter(function (elem, index, self) {
            return index === self.indexOf(elem);

        });
        let uniq = {};
        this.questiondata = questions.filter(obj => !uniq[obj.questionID] && (uniq[obj.questionID] = true));

        this.RCSWatsonQuestion[0] = false;
        this.RCSWatsonQuestion[1] = false;
        this.RCSWatsonQuestion[2] = false;

        this.RCSWatsonCount = 0;
    }

    onRCSContractSelect() {
        let questions = this.RCSContractData.sort(i => i.questionOrder);
        this.questiondataContract = questions.filter(function (elem, index, self) {
            return index === self.indexOf(elem);

        });
        let uniq = {};
        this.questiondataContract = questions.filter(obj => !uniq[obj.questionID] && (uniq[obj.questionID] = true));

        this.RCSContractQuestion[0] = false;
        this.RCSContractQuestion[1] = false;
    }

    RCSWatsonChange(ans, index, id) {
        let RCSquestiondata = {
            questionID: id,
            ans: ans
        };
        if (this.RCSquestiondata && this.RCSquestiondata.find(x => x.questionID === id)) {
            this.RCSquestiondata.find(x => x.questionID == id).ans = ans;
        } else {
            this.RCSquestiondata.push(RCSquestiondata);

        }

        this.RCSWatsonData = JSON.parse(JSON.stringify(this.RCSWatsonDataDup));
        if (ans === 'yes') {
            if (this.RCSWatsonCount < 3 && !this.questiondata[index].ans) {
                this.RCSWatsonCount++;
            }
            this.RCSWatsonvalues[String(id)] = false;
            let message = this.RCSWatsonData.find(x => x.questionID === id && x.answer === 'Yes');
            this.RCSWatsonQuestion[index] = true;
            this.questiondata[index].ans = true;
            this.questiondata[index].message = message.message;

        }
        if (ans === 'no') {
            if (this.RCSWatsonCount < 3 && !this.questiondata[index].ans) {
                this.RCSWatsonCount++;
            }
            this.RCSWatsonvalues[String(id)] = true;
            let message = this.RCSWatsonData.find(x => x.questionID === id && x.answer === 'No');
            this.RCSWatsonQuestion[index] = false;
            this.questiondata[index].ans = true;
            this.questiondata[index].message = message.message;
        }

        if (ans === 'notsure') {
            if (this.RCSWatsonCount < 3 && !this.questiondata[index].ans) {
                this.RCSWatsonCount++;
            }
            this.RCSWatsonvalues[String(id)] = false;
            let message = this.RCSWatsonData.find(x => x.questionID === id && x.answer === 'NotSure');
            this.RCSWatsonQuestion[index] = true;
            this.questiondata[index].ans = true;
            this.questiondata[index].message = message.message;
        }
        this.determineRCSEnable();
    }

    determineRCSEnable() {

        if (this.RCSWatsonvalues['3'] === true && this.RCSWatsonvalues['1'] === true && this.RCSWatsonCount === 3) {
            this.enableRCSWatson = true;
        } else if (this.RCSWatsonvalues['3'] === false || this.RCSWatsonvalues['1'] === false) {
            this.enableRCSWatson = false;
        }
    }
    RCSContractChange(ans, index, id) {
        let RCSquestiondata = {
            questionID: id,
            ans: ans
        };
        if (this.RCSquestiondata && this.RCSquestiondata.find(x => x.questionID === id)) {
            this.RCSquestiondata.find(x => x.questionID == id).ans = ans;
        } else {
            this.RCSquestiondata.push(RCSquestiondata);
        }
        this.RCSContractData = JSON.parse(JSON.stringify(this.RCSContractDataDup));
        if (ans === 'yes') {
            if (this.RCSContractcount < 2 && !this.questiondataContract[index].ans) {
                this.RCSContractcount++;
            }
            this.RCSContractvalues[String(id)] = false;
            let message = this.RCSContractData.find(x => x.questionID === id && x.answer === 'Yes');
            this.RCSContractQuestion[index] = true;
            this.questiondataContract[index].ans = true;
            this.questiondataContract[index].message = message.message;

        }
        if (ans === 'no') {
            if (this.RCSContractcount < 2 && !this.questiondataContract[index].ans) {
                this.RCSContractcount++;
            }
            this.RCSContractvalues[String(id)] = true;
            let message = this.RCSContractData.find(x => x.questionID === id && x.answer === 'No');
            this.RCSContractQuestion[index] = true;
            this.questiondataContract[index].ans = true;
            this.questiondataContract[index].message = message.message;
        }

        if (ans === 'notsure') {
            if (this.RCSContractcount < 2 && !this.questiondataContract[index].ans) {
                this.RCSContractcount++;
            }
            this.RCSContractvalues[String(id)] = false;
            let message = this.RCSContractData.find(x => x.questionID === id && x.answer === 'NotSure');
            this.RCSContractQuestion[index] = true;
            this.questiondataContract[index].ans = true;
            this.questiondataContract[index].message = message.message;
        }
        this.determineRCSContractEnable();
    }
    determineRCSContractEnable() {

        if (this.RCSContractvalues['4'] === true && this.RCSContractcount === 2) {
            this.enableRCSContract = true;
        } else if (this.RCSContractcount === 2) {
            this.enableRCSContract = false;
        }
    }

    allowSMEsToAddNewProjectsEvent(event: any) {
        this.canSMEAddProjects = event.target.checked
    }

    allowSMEsToAddNewEmployeesEvent(event: any) {
        this.canSMEAddEmployees = event.target.checked
    }

    _keyUp(event: any) {
        const pattern = /[0-9\.\-\ ]/;
        let inputChar = String.fromCharCode(event.key);

        if (!pattern.test(inputChar)) {
            // invalid character, prevent input
            event.preventDefault();
        }
    }
}


